import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import Avatar from "../inputs/Avatar";
import { Col, Form } from "react-bootstrap";
import $ from "jquery";

const UserPersonalData = (props) => {
    const { t } = useTranslation();
    const { formChanged, setFormChanged, user, avatar, setAvatar, blockForm, setUser, editView } = props;

    const textInputs = [
        { name: "name", req: true },
        { name: "surname", req: true },
        { name: "phone", req: true },
        { name: "ig", req: false },
    ];

    return (
        <Fragment>
            <Avatar user={user} avatar={avatar} setAvatar={setAvatar} formChanged={formChanged} setFormChanged={setFormChanged} />
            {!editView && (
                <Fragment>
                    <p className="mb-2">
                        {t("users.roles")}:{" "}
                        {user.user_roles.map((role, i) => (
                            <Fragment key={i}>
                                {role.user_role_name}
                                {i + 1 < user.user_roles.length ? ", " : ""}
                            </Fragment>
                        ))}
                    </p>
                    <p className="mb-2">
                        {t("users.status")}: {user.user_status}
                    </p>
                    <p>
                        {t("users.longBooking")}: {user.user_long_booking === "Y" ? t("yes") : t("no")}
                    </p>
                </Fragment>
            )}
            {textInputs.map((e, i) => (
                <Col xs={12} lg={6} key={i}>
                    <Form.Group className="mb-3" controlId={`addUserForm${e.name}`}>
                        <Form.Label className="w-100">
                            {t(`addUserForm.${e.name}`)} {e.req && <span className="text-danger">*</span>}
                        </Form.Label>
                        <Form.Control
                            value={user[e.name]}
                            onChange={(el) => {
                                $(`#addUserForm${e.name}`).removeClass("is-invalid");
                                setUser({ ...user, [e.name]: el.target.value });
                                setFormChanged(true);
                            }}
                            placeholder={t(`addUserForm.${e.name}Placeholder`)}
                            type="text"
                            disabled={blockForm}
                        />
                    </Form.Group>
                </Col>
            ))}
            <Col xs={12} lg={12}>
                <Form.Group className="mb-3" controlId={`addUserFormAddress`}>
                    <Form.Label className="w-100">{t(`addUserForm.address`)}</Form.Label>
                    <Form.Control
                        value={user.address}
                        onChange={(el) => {
                            $("#addUserFormAddress").removeClass("is-invalid");
                            setUser({ ...user, address: el.target.value });
                            setFormChanged(true);
                        }}
                        placeholder={t(`addUserForm.addressPlaceholder`)}
                        as="textarea"
                        disabled={blockForm}
                    />
                </Form.Group>
            </Col>
        </Fragment>
    );
};

export default UserPersonalData;
